import UnauthAppointmentsPage from "./UnauthAppointmentsPage";

export default UnauthAppointmentsPage;

export * from "./UnauthAppointmentsPage";
